/**
 * Get value of given breakpoint based on Sass breakpoints
 *
 * @author Rianne Oosthoek
 * @param  {string} name of the breakpoint (small, medium, etc.)
 * @return {int}    breakpoint size in pixels
 */
window.getBreakpointSize = function( size ){
    // Loop through Foundation breakpoints
    for( var i in Foundation.MediaQuery.queries ) {
        var query = Foundation.MediaQuery.queries[i];
        if( size === query.name ){
            // Split media query string so only the em value remains
            var str = query.value;
            var split_str = str.split('min-width: ')[1];
            // Split string and parse em value to and get px value
            var query_value = ( parseFloat( split_str.split('em)')[0] ) * 16 ) ;

            return query_value;
        }
    }
};



// WEBPACK FOOTER //
// ./resources/assets/js/frontend/utilities/breakpoint-size.js